import React, { useEffect, useState } from 'react'
import EnquiryDetailsCard from '../leadpages/EnquiryDetailsCard'
import { useLocation, useParams } from 'react-router-dom';
import { AppBar, Backdrop, CircularProgress, Grid, Paper, Toolbar, Typography } from '@mui/material';
import EnquiryActivityCard from '../leadpages/EnquiryActivityCard';
import EnquiryAddNote from '../leadpages/EnquiryAddNote';
import ViewEnquiry from '../../../pages/advisorPages/viewEnquiry/ViewEnquiry';
import LeadStepper from '../../../components/stepper/Stepper';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function EnquiryDetails({enquiryDetails}) {

    const { leadNo } = useParams();
    const location = useLocation();
 const storedData = JSON.parse(localStorage.getItem("enquiryData"));
    const [enquiryData, setEnquiryData] = useState(enquiryDetails || null)
    const [loading, setLoading] = useState(false)
    const [qualificationList, setQualificationList] = useState([]);

 

   const fetchEnquiryData = async (studentId) => {
      //const apiUrl = `${API_ENDPOINT}route/getstudent/${studentId}`; // Adjust the API endpoint as needed
      const apiUrl = `${API_ENDPOINT}lmenquirycrm/${studentId}`;
      try {
        const response = await fetch(apiUrl);
    
        if (!response.ok) {
          // Handle non-successful responses (e.g., 404 Not Found, 500 Internal Server Error)
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }
    
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch data');
      }
    };


    const fetchQualificationDetails = async (enqId) => {
    const apiUrl = `${API_ENDPOINT}qualificationDetails/${enqId}`;

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(
          `Error: ${response.status} - ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching qualification details:", error);
      return [];
    }
  };

    useEffect(() => {
      setLoading(true);
      const fetchEnquiryInfo = async () => {
        //setLoading(true);
        try {
          const data = await fetchEnquiryData(leadNo); // Assuming fetchEnquiryData takes a student ID as an argument
          setEnquiryData(data);
          const qualifications = await fetchQualificationDetails(leadNo);

          setQualificationList(qualifications);

          console.log("Qualifications:", qualifications);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching enquiry data:', error);
          setLoading(false);
          // Handle error as needed
        }
      };
  
      if (!enquiryData && leadNo) {
        fetchEnquiryInfo();
      } else {
        setLoading(false);
      }
    }, [enquiryData, leadNo]);

    const headerHeight = 264; 
                    // console.log("qualificationList", qualificationList);

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>Fetching</Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      {enquiryData ? (
      <Grid container >
      {/* Sticky wrapper for LeadStepper and EnquiryDetailsCard */}
      <Grid item xs={12} style={{ position: 'sticky', top: 0, zIndex: 10}}>
        <LeadStepper enquiryData={enquiryData}  />
      </Grid>
  
      <Grid item xs={12} style={{ position: 'sticky', top: 60, zIndex: 10 }}>
        <Paper elevation={3}>
          <EnquiryDetailsCard enquiryData={enquiryData} />
        </Paper>
      </Grid>

  
      <Grid item xs={12} style={{ position: "relative",  }}>
          <ViewEnquiry
              enquiryData={enquiryData}
              headerHeight={headerHeight}
              enquiryPersonalDetails={storedData?.enquirySummary}
              qualificationList={qualificationList}
              setQualificationList={setQualificationList}
          />
      </Grid>
    </Grid>
      ):(
        <p>No lead details found.</p>
      )}
      </>
     
  )
}

export default EnquiryDetails